module.exports = __webpack_public_path__ + "static/media/pax.e283979f.svg";